(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1350],{

/***/ 45971:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/non-benefit",
      function () {
        return __webpack_require__(55702);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81541);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89961);
/* harmony import */ var _components_atom_icon_Arrow_BreadCrumbArrow__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22522);
/* harmony import */ var _constants_zIndex__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31591);
/* harmony import */ var _styles_layout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64952);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78287);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  visibility: ",
        ";\n  position: ",
        ";\n  display: flex;\n\n  @media screen and (max-width: ",
        ") {\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  svg {\n    margin: 0 2px;\n  }\n  p:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px 24px 0;\n  position: relative;\n  z-index: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var CustomBreadCrumbs = function(param) {
    var visible = param.visible, breadCrumbs = param.breadCrumbs;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var onClickBreadCrumb = function(name) {
        (0,_utils_logger__WEBPACK_IMPORTED_MODULE_7__/* .logger */ .kg)({
            pageName: (0,_utils_logger__WEBPACK_IMPORTED_MODULE_7__/* .getPageName */ .j0)(router),
            eventName: "breadcrumb_".concat(name, "_click")
        });
    };
    var breadCrumbsWithHome = [
        {
            label: "홈",
            url: "/",
            logName: "home"
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(breadCrumbs));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        visible: visible,
        id: "breadcrumbs",
        children: breadCrumbsWithHome.map(function(item, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Path, {
                role: "button",
                onClick: function() {
                    return onClickBreadCrumb(item.logName);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: item.url,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                children: item.label
                            })
                        })
                    }),
                    index !== breadCrumbsWithHome.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_icon_Arrow_BreadCrumbArrow__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                ]
            }, item.label);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomBreadCrumbs);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-aeec3b7-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.typography.UI13M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
}, function(param) {
    var visible = param.visible;
    return visible ? "visible" : "hidden";
}, function(param) {
    var visible = param.visible;
    return visible ? "static" : "absolute";
}, _styles_layout__WEBPACK_IMPORTED_MODULE_10__/* .Tablet */ .YD, function(param) {
    var theme = param.theme;
    return theme.typography.UI14R;
});
var Path = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-aeec3b7-1"
})(_templateObject1());
var BreadCrumbsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-aeec3b7-2"
})(_templateObject2(), _constants_zIndex__WEBPACK_IMPORTED_MODULE_6__/* .zIndex.BreadCrumb */ .W.BreadCrumb);
CustomBreadCrumbs.Wrapper = BreadCrumbsWrapper;


/***/ }),

/***/ 47064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89961);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Divider = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fc14f8a-0"
})(_templateObject(), function(param) {
    var _height = param.height, height = _height === void 0 ? "1px" : _height, _color = param.color, color = _color === void 0 ? "#efefef" : _color, _isVisible = param.isVisible, isVisible = _isVisible === void 0 ? true : _isVisible, _margin = param.margin, margin = _margin === void 0 ? "0" : _margin;
    return "\n    display: ".concat(isVisible ? "block" : "none", ";\n    height: ").concat(height, ";\n    background-color: ").concat(color, ";\n    margin: ").concat(margin, ";\n  ");
});
/* harmony default export */ __webpack_exports__["Z"] = (Divider);


/***/ }),

/***/ 40795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var ArrowsButtonRightMin = function(param) {
    var _color = param.color, color = _color === void 0 ? "#8D9297" : _color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M5.2998 11.625L8.72168 8.28125L5.2998 4.95312L6.2373 4L10.6436 8.28125L6.2373 12.5781L5.2998 11.625Z",
            fill: color
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowsButtonRightMin);


/***/ }),

/***/ 22522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var BreadCrumbArrow = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.557 2.67311C5.43361 2.69613 5.32045 2.77137 5.25001 2.87723C5.20047 2.95168 5.17989 3.01695 5.17636 3.11082C5.17199 3.22681 5.19204 3.30295 5.25091 3.39399C5.26614 3.41752 5.75502 3.90878 7.5576 5.71185L9.84498 7.99985L7.5576 10.2879C5.75502 12.0909 5.26614 12.5822 5.25091 12.6057C5.19204 12.6968 5.17199 12.7729 5.17636 12.8889C5.17896 12.9579 5.18893 13.0034 5.21347 13.0579C5.26381 13.1698 5.37402 13.27 5.49032 13.3095C5.59721 13.3459 5.73841 13.3389 5.83633 13.2924C5.92155 13.2519 5.7554 13.4152 8.27956 10.891C9.62615 9.54438 10.6303 8.537 10.6468 8.51612C10.8436 8.26702 10.882 7.92846 10.7457 7.64359C10.7179 7.58549 10.6842 7.53099 10.6468 7.48359C10.6303 7.46271 9.62615 6.45533 8.27956 5.10871C6.23381 3.06291 5.93645 2.76711 5.90463 2.74629C5.82035 2.69112 5.75534 2.67081 5.65514 2.66833C5.61039 2.66722 5.58087 2.66866 5.557 2.67311Z",
            fill: "#A9AEB1"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumbArrow);


/***/ }),

/***/ 23773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var ValidationCheck = function(param) {
    var _size = param.size, size = _size === void 0 ? 22 : _size, _fill = param.fill, fill = _fill === void 0 ? "#FD7E14" : _fill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.6177 4.08603C17.308 4.10941 17.0333 4.23068 16.8203 4.43801C16.7884 4.46904 16.6991 4.57074 16.6217 4.66402C16.5444 4.7573 14.562 7.15634 12.2165 9.99522C9.87092 12.8341 7.94719 15.1617 7.94154 15.1677C7.93199 15.1779 7.83829 15.0591 6.61926 13.4912C5.89766 12.5631 5.28336 11.7758 5.25414 11.7416C5.04815 11.5005 4.76686 11.3561 4.42726 11.3171C4.03981 11.2727 3.67174 11.4012 3.385 11.681C3.26909 11.7941 3.18925 11.9037 3.1252 12.0379C3.03536 12.226 2.99499 12.428 3.002 12.6544C3.01031 12.9231 3.08506 13.1368 3.24943 13.3616C3.29208 13.42 6.06564 16.9865 6.13862 17.0768C6.20396 17.1577 6.35713 17.3121 6.4381 17.3787C7.01938 17.8566 7.7708 18.0264 8.49981 17.8445C8.94568 17.7333 9.36276 17.4771 9.67163 17.1248C9.72674 17.062 18.6401 6.27711 18.7207 6.17582C18.859 6.00194 18.9475 5.80736 18.9848 5.59522C19.0002 5.50737 19.0033 5.32047 18.9909 5.21907C18.9532 4.91081 18.8316 4.66495 18.612 4.4526C18.337 4.18674 17.988 4.05808 17.6177 4.08603Z",
            fill: fill
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ValidationCheck);


/***/ }),

/***/ 53214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89961);
/* harmony import */ var _utils_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60288);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  position: relative;\n  border-radius: 50%;\n  overflow: hidden;\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 50%;\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n  z-index: 1;\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  background-color: white;\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var NurseProfile = function(param) {
    var url = param.url, size = param.size;
    var resizingImgUrl = (0,_utils_image__WEBPACK_IMPORTED_MODULE_2__/* .resizingImg */ .Kp)({
        originUrl: url,
        width: size * 3,
        height: size * 3,
        quality: 100
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        size: size,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(NurseImage, {
                url: resizingImgUrl,
                size: size
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BackgroundImage, {
                size: size
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NurseProfile);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-4426003f-0"
})(_templateObject(), function(param) {
    var theme = param.theme, size = param.size;
    return "\n    border: 1px solid ".concat(theme.color.gray200, ";\n    width: ").concat(size, "px;\n    height: ").concat(size, "px;\n  ");
});
var NurseImage = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-4426003f-1"
})(_templateObject1(), function(param) {
    var url = param.url, size = param.size;
    return "\n    background-image: url(".concat(url, ");\n    width: ").concat(size - 1, "px;\n    height: ").concat(size - 1, "px;\n");
});
var BackgroundImage = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-4426003f-2"
})(_templateObject2(), function(param) {
    var size = param.size;
    return "\n    width: ".concat(size - 1, "px;\n    height: ").concat(size - 1, "px;\n  ");
});


/***/ }),

/***/ 22260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(89961);
/* harmony import */ var _assets_lottie_loading_dot_ongoing_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65196);
/* harmony import */ var _assets_lottie_loading_dot_wait_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28989);
/* harmony import */ var _components_atom_CustomLottieIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84655);
/* harmony import */ var _components_molecules_NurseProfile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53214);
/* harmony import */ var _components_molecules_QuestionList_QuestionItem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38427);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44376);
/* harmony import */ var _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(72271);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    & > div {\n      border-bottom: ",
        ";\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n\n  ",
        ";\n\n  &:div {\n    margin-right: 8px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  position: relative;\n  margin-right: 8px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  div {\n    border: 2px solid white;\n    border-radius: 50%;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}










var RelatedQuestionItem = function(param) {
    var questionCard = param.questionCard, onClickRelatedQna = param.onClickRelatedQna, isLast = param.isLast;
    var questionPid = questionCard.question.questionPid;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, {
        isLast: isLast,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_molecules_QuestionList_QuestionItem__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            isPaidQuestion: false,
            questionCard: questionCard,
            onClickQuestion: function() {
                return onClickRelatedQna(questionPid);
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_molecules_QuestionList_QuestionItem__WEBPACK_IMPORTED_MODULE_7__/* ["default"].BottomLeft */ .Z.BottomLeft, {
                children: questionCard.answeredStatus === _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_9__/* .QuestionAnsweredStatus.Answered */ .G2.Answered ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(QuestionBottomAnswerStatus, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(QuestionDoctorImageWrapper, {
                            children: questionCard.answererProfileImageUrls.slice(0, 5).map(function(image, key) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(QuestionDoctorImage, {
                                    imageKey: key,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_molecules_NurseProfile__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        url: image,
                                        size: 28
                                    })
                                }, "answered-doctor-".concat(key));
                            })
                        }),
                        questionCard.answererCount,
                        "개의 답변"
                    ]
                }) : questionCard.question.status !== _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_9__/* .QuestionStatus.AwaitingBasicAnswer */ .xV.AwaitingBasicAnswer ? // 답변 중 / 답변 확인 중
                // 목록
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(QuestionBottomAnswerStatus, {
                    fontColor: questionCard.answeredStatus === _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_9__/* .QuestionAnsweredStatus.Answering */ .G2.Answering ? _styles_theme__WEBPACK_IMPORTED_MODULE_8__/* ["default"].color.primary500 */ .Z.color.primary500 : _styles_theme__WEBPACK_IMPORTED_MODULE_8__/* ["default"].color.blue500 */ .Z.color.blue500,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_CustomLottieIcon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            width: 24,
                            height: 24,
                            animationData: questionCard.answeredStatus === _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_9__/* .QuestionAnsweredStatus.Answering */ .G2.Answering ? _assets_lottie_loading_dot_ongoing_json__WEBPACK_IMPORTED_MODULE_3__ : _assets_lottie_loading_dot_wait_json__WEBPACK_IMPORTED_MODULE_4__,
                            style: {
                                marginRight: 8
                            }
                        }),
                        questionCard.answeredStatusText
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {})
            })
        }, questionPid)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RelatedQuestionItem);
var Container = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-e56f312d-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n  &: hover {\n    background: ".concat(theme.color.gray30, ";\n  };\n  &: active {\n    background: ").concat(theme.color.gray50, ";\n  };\n  ");
}, function(param) {
    var theme = param.theme, isLast = param.isLast;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)(_templateObject(), isLast ? "none" : "1px solid ".concat(theme.color.gray40));
});
var QuestionBottomAnswerStatus = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e56f312d-1"
})(_templateObject2(), function(param) {
    var theme = param.theme, fontColor = param.fontColor;
    return "\n    ".concat(theme.typography.UI14SB, ";\n    color: ").concat(fontColor !== null && fontColor !== void 0 ? fontColor : theme.color.gray700, ";\n  ");
});
var QuestionDoctorImageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e56f312d-2"
})(_templateObject3());
var QuestionDoctorImage = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e56f312d-3"
})(_templateObject4(), function(param) {
    var imageKey = param.imageKey;
    return "\n    margin-left: -".concat(imageKey ? 8 : 0, "px;\n    z-index: ").concat(5 - imageKey, ";\n  ");
});


/***/ }),

/***/ 29305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var qrcode_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29782);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89961);
/* harmony import */ var _components_molecules_BottomSheet__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46870);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px 20px 32px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  color: ",
        ";\n  padding: 0 4px;\n  white-space: pre-line;\n  margin-bottom: 20px;\n  word-break: keep-all;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  color: ",
        ";\n  margin-bottom: 24px;\n  text-align: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-top: 24px;\n  margin-bottom: 8px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 141px;\n  object-fit: cover;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        "\n    color: ",
        ";\n    background-color: ",
        ";\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 56px;\n  border-radius: 12px;\n  margin-top: 40px;\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




var DiagnosisAppInstallBottomSheet = function(param) {
    var buttonId = param.buttonId, onClose = param.onClose, title = param.title, _treatmentMedicineId = param.treatmentMedicineId, treatmentMedicineId = _treatmentMedicineId === void 0 ? "0" : _treatmentMedicineId, description = param.description, qrCodeUrl = param.qrCodeUrl, onClickOpenAppInstallLink = param.onClickOpenAppInstallLink, client = param.client;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_molecules_BottomSheet__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
        isOpened: true,
        onClickOverlay: onClose,
        index: 500,
        children: client.isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Title, {
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImageWrapper, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ReceiptImage, {
                        src: "/images/nonBenefit/image_mobile_seo.png",
                        alt: "계산서 이미지"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubmitButton, {
                    id: buttonId ? buttonId : "selected-medicine-".concat(treatmentMedicineId),
                    onClick: onClickOpenAppInstallLink,
                    children: "앱에서 최저가 확인하기"
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Title, {
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(QRCodeWrapper, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(qrcode_react__WEBPACK_IMPORTED_MODULE_2__/* .QRCodeCanvas */ .Qd, {
                        value: qrCodeUrl,
                        size: 120
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Description, {
                    children: description
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DiagnosisAppInstallBottomSheet);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-15deb100-0"
})(_templateObject());
var Title = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-15deb100-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.typography.UI22SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray900;
});
var Description = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-15deb100-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.typography.UI15R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
});
var QRCodeWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-15deb100-3"
})(_templateObject3());
var ImageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-15deb100-4"
})(_templateObject4());
var ReceiptImage = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-15deb100-5"
})(_templateObject5());
var SubmitButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-15deb100-6"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject6(), theme.typography.UI17SB, theme.color.white, theme.color.primary600);
});


/***/ }),

/***/ 96159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ useNonBenefitMedicinesForSeoQuery; },
/* harmony export */   "X9": function() { return /* binding */ useNonBenefitPriceTotalSummaryQuery; },
/* harmony export */   "Y1": function() { return /* binding */ useNonBenefitMapNearbyPharmacySearchTabsQuery; },
/* harmony export */   "Y6": function() { return /* binding */ useSearchNonF2fDoctorsForSeoByUserQuery; }
/* harmony export */ });
/* unused harmony exports NonBenefitMedicinesForSeoDocument, NonBenefitPriceTotalSummaryDocument, SearchNonF2fDoctorsForSeoByUserDocument, NonBenefitMapNearbyPharmacySearchTabsDocument */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36492);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);


var NonBenefitMedicinesForSeoDocument = "\n    query NonBenefitMedicinesForSeo {\n  nonBenefitMedicinesForSeo {\n    id\n    medicineName\n    medicineDescription\n    units {\n      id\n      unit\n      unitType\n      unitTypeDisplayName\n    }\n    treatment {\n      id\n      categoryId\n      isBenefit\n      name\n    }\n  }\n}\n    ";
var useNonBenefitMedicinesForSeoQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(variables === undefined ? [
        "NonBenefitMedicinesForSeo"
    ] : [
        "NonBenefitMedicinesForSeo",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(NonBenefitMedicinesForSeoDocument, "NonBenefitMedicinesForSeo", variables), options);
};
useNonBenefitMedicinesForSeoQuery.getKey = function(variables) {
    return variables === undefined ? [
        "NonBenefitMedicinesForSeo"
    ] : [
        "NonBenefitMedicinesForSeo",
        variables
    ];
};
useNonBenefitMedicinesForSeoQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(NonBenefitMedicinesForSeoDocument, "NonBenefitMedicinesForSeo", variables, options);
};
var NonBenefitPriceTotalSummaryDocument = "\n    query NonBenefitPriceTotalSummary($treatmentMedicineId: ID!, $regionCode: String!) {\n  nonBenefitPriceTotalSummary(\n    treatmentMedicineId: $treatmentMedicineId\n    regionCode: $regionCode\n  ) {\n    nationalSummaries {\n      averagePrice\n      minPrice\n      treatmentMedicineUnitId\n      unitDisplayName\n      unitTypeDisplayName\n    }\n    regionSummaries {\n      averagePrice\n      minPrice\n      treatmentMedicineUnitId\n      unitDisplayName\n      unitTypeDisplayName\n    }\n  }\n}\n    ";
var useNonBenefitPriceTotalSummaryQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "NonBenefitPriceTotalSummary",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(NonBenefitPriceTotalSummaryDocument, "NonBenefitPriceTotalSummary", variables), options);
};
useNonBenefitPriceTotalSummaryQuery.getKey = function(variables) {
    return [
        "NonBenefitPriceTotalSummary",
        variables
    ];
};
useNonBenefitPriceTotalSummaryQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(NonBenefitPriceTotalSummaryDocument, "NonBenefitPriceTotalSummary", variables, options);
};
var SearchNonF2fDoctorsForSeoByUserDocument = "\n    query SearchNonF2fDoctorsForSeoByUser($request: NonF2fDoctorSeoSearchRequestInput!, $contactType: DiagnosisContactType!) {\n  searchNonF2fDoctorsForSeoByUser(request: $request) {\n    doctorId\n    name\n    medicineType\n    readyForVideoCall\n    publicId\n    nonBenefitTreatmentsV2(contactType: $contactType) {\n      nonBenefitTreatmentUnitInfos {\n        originalPrice\n        unitDisplayName\n        treatmentMedicineUnitId\n      }\n    }\n    detail {\n      profileImageUrl\n    }\n    departments {\n      name\n      isProfessional\n    }\n    hospital {\n      hospitalName\n      hospitalAddress {\n        jibunAddress\n        roadAddress\n        regionByDepth {\n          siDoName\n          siGunGuName\n          legalEupMyeonDongName\n        }\n      }\n    }\n  }\n}\n    ";
var useSearchNonF2fDoctorsForSeoByUserQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "SearchNonF2fDoctorsForSeoByUser",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchNonF2fDoctorsForSeoByUserDocument, "SearchNonF2fDoctorsForSeoByUser", variables), options);
};
useSearchNonF2fDoctorsForSeoByUserQuery.getKey = function(variables) {
    return [
        "SearchNonF2fDoctorsForSeoByUser",
        variables
    ];
};
useSearchNonF2fDoctorsForSeoByUserQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchNonF2fDoctorsForSeoByUserDocument, "SearchNonF2fDoctorsForSeoByUser", variables, options);
};
var NonBenefitMapNearbyPharmacySearchTabsDocument = "\n    query NonBenefitMapNearbyPharmacySearchTabs {\n  nonBenefitMapNearbyPharmacySearchTabs {\n    id\n    name\n    diagnosisType\n    diagnosisTypeId\n    sortTypes {\n      type\n      title\n    }\n    filters {\n      type\n      title\n      description\n      mode\n      activeIconUrl\n      inactiveIconUrl\n      subFilters {\n        type\n        title\n        description\n        mode\n        inactiveIconUrl\n        activeIconUrl\n      }\n    }\n  }\n}\n    ";
var useNonBenefitMapNearbyPharmacySearchTabsQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(variables === undefined ? [
        "NonBenefitMapNearbyPharmacySearchTabs"
    ] : [
        "NonBenefitMapNearbyPharmacySearchTabs",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(NonBenefitMapNearbyPharmacySearchTabsDocument, "NonBenefitMapNearbyPharmacySearchTabs", variables), options);
};
useNonBenefitMapNearbyPharmacySearchTabsQuery.getKey = function(variables) {
    return variables === undefined ? [
        "NonBenefitMapNearbyPharmacySearchTabs"
    ] : [
        "NonBenefitMapNearbyPharmacySearchTabs",
        variables
    ];
};
useNonBenefitMapNearbyPharmacySearchTabsQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(NonBenefitMapNearbyPharmacySearchTabsDocument, "NonBenefitMapNearbyPharmacySearchTabs", variables, options);
};


/***/ }),

/***/ 55702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ non_benefit; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(83651);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(62230);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/atom/CustomBreadCrumbs.tsx
var CustomBreadCrumbs = __webpack_require__(12429);
// EXTERNAL MODULE: ./src/components/atom/Divider.tsx
var Divider = __webpack_require__(47064);
// EXTERNAL MODULE: ./src/components/atom/buttons/FixedButton.tsx
var FixedButton = __webpack_require__(16121);
// EXTERNAL MODULE: ./src/components/common/LinkTag/index.tsx
var LinkTag = __webpack_require__(23889);
// EXTERNAL MODULE: ./src/components/common/communication/magazine/ListMagazineLine.tsx + 2 modules
var ListMagazineLine = __webpack_require__(79476);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/templates/mobile/communication/Qna/QnaDetailMobileTemplate/QnaRelatedQuestion/RelatedQuestionItem/index.tsx
var RelatedQuestionItem = __webpack_require__(22260);
// EXTERNAL MODULE: ./src/components/atom/icon/ValidationCheck.tsx
var ValidationCheck = __webpack_require__(23773);
// EXTERNAL MODULE: ./src/constants/nonBenefit/index.ts
var nonBenefit = __webpack_require__(2935);
;// CONCATENATED MODULE: ./src/components/templates/nonBenefit/home/components/NonBenefitCategoryInformation.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 24px 8px;\n  white-space: pre-line;\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 24px 12px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 12px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 3px;\n  width: 22px;\n  height: 22px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & ul {\n    margin-top: 8px;\n    & > li {\n      position: relative;\n      ",
        ";\n      color: ",
        ";\n      list-style: none;\n      margin-left: 20px;\n      &::before {\n        content: '';\n        position: absolute;\n        top: 50%;\n        left: -10px;\n        width: 3px;\n        height: 3px;\n        border-radius: 50%;\n        background-color: ",
        ";\n        transform: translate(-3px, -50%);\n      }\n    }\n  }\n  & p {\n    ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




var NonBenefitCategoryInformation = function(param) {
    var selectedMedicine = param.selectedMedicine;
    if (!nonBenefit/* NON_BENEFIT_INFORMATIONS */.S["".concat(selectedMedicine.id)]) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryInformationArticle, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryInformationHeader, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryInformationTitle, {
                    children: "".concat(selectedMedicine.treatmentProductMedicineName, " 처방 받기 전 체크리스트")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryInformationContent, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryInformationList, {
                    children: nonBenefit/* NON_BENEFIT_INFORMATIONS */.S["".concat(selectedMedicine.id)].map(function(information) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryInformationListItem, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ValidationCheck/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InformationDetailWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationTitle, {
                                            children: information.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationContent, {
                                            dangerouslySetInnerHTML: {
                                                __html: information.description
                                            }
                                        })
                                    ]
                                })
                            ]
                        }, "non-benefit-category-info-".concat(selectedMedicine.id, "-").concat(information.title));
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_NonBenefitCategoryInformation = (NonBenefitCategoryInformation);
var CategoryInformationArticle = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    componentId: "sc-468809b5-0"
})(_templateObject());
var CategoryInformationHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-468809b5-1"
})(_templateObject1());
var CategoryInformationTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-468809b5-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.typography.UI22SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray700;
});
var CategoryInformationContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-468809b5-3"
})(_templateObject3());
var CategoryInformationList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-468809b5-4"
})(_templateObject4());
var CategoryInformationListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-468809b5-5"
})(_templateObject5());
var IconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-468809b5-6"
})(_templateObject6());
var InformationDetailWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-468809b5-7"
})(_templateObject7());
var InformationTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-468809b5-8"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.typography.UI17SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
});
var InformationContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-468809b5-9"
})(_templateObject9(), function(param) {
    var theme = param.theme;
    return theme.typography.UI15R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI15R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
});

// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(4611);
;// CONCATENATED MODULE: ./src/components/templates/nonBenefit/home/components/NonBenefitSearchDoctorItem.tsx

function NonBenefitSearchDoctorItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    NonBenefitSearchDoctorItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NonBenefitSearchDoctorItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"
    ]);
    NonBenefitSearchDoctorItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NonBenefitSearchDoctorItem_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 4px;\n"
    ]);
    NonBenefitSearchDoctorItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NonBenefitSearchDoctorItem_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  color: ",
        ";\n"
    ]);
    NonBenefitSearchDoctorItem_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NonBenefitSearchDoctorItem_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  color: ",
        ";\n"
    ]);
    NonBenefitSearchDoctorItem_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NonBenefitSearchDoctorItem_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 6px;\n"
    ]);
    NonBenefitSearchDoctorItem_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function NonBenefitSearchDoctorItem_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  color: ",
        ";\n"
    ]);
    NonBenefitSearchDoctorItem_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function NonBenefitSearchDoctorItem_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 2px;\n"
    ]);
    NonBenefitSearchDoctorItem_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function NonBenefitSearchDoctorItem_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  color: ",
        ";\n"
    ]);
    NonBenefitSearchDoctorItem_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function NonBenefitSearchDoctorItem_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  color: ",
        ";\n"
    ]);
    NonBenefitSearchDoctorItem_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 6px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    padding: 0 4px;\n    background-color: ",
        ";\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 2px;\n  height: 20px;\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    background-color: ",
        ";\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 72px;\n  height: 72px;\n  background-image: url(",
        ");\n  background-size: cover;\n  border-radius: 50%;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}






var NonBenefitSearchDoctorItem = function(param) {
    var doctor = param.doctor, onClick = param.onClick, lastItem = param.lastItem, treatmentMedicineUnitId = param.treatmentMedicineUnitId, cheapestPrice = param.cheapestPrice;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NonBenefitDoctorItemWrapper, {
                onClick: onClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorInfoWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorNameWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorName, {
                                        children: doctor.doctorDisplayName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorHospitalName, {
                                        children: doctor.hospitalName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorMedicinePriceWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorMedicinePrice, {
                                        cheapest: doctor.isCheapestTreatmentPrice(treatmentMedicineUnitId, cheapestPrice),
                                        children: doctor.getNonBenefitTreatmentPriceTextByTreatmentMedicineUnitId(treatmentMedicineUnitId)
                                    }),
                                    doctor.isCheapestTreatmentPrice(treatmentMedicineUnitId, cheapestPrice) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorMedicinePriceCheepWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                name: "local_offer",
                                                size: 14,
                                                filled: true,
                                                color: theme/* default.color.primary700 */.Z.color.primary700
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorMedicinePriceCheap, {
                                                children: "닥터나우 최저가"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorAddress, {
                                children: doctor.hospitalAddress
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorDepartmentWrapper, {
                                children: [
                                    doctor.professionalDepartments.map(function(department) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorDepartment, {
                                            children: [
                                                department.name,
                                                " 전문의"
                                            ]
                                        }, "department-".concat(department.name));
                                    }),
                                    doctor.readyForVideoCall && /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorVideoCall, {
                                        children: "영상진료"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorProfileImage, {
                        src: doctor.profileImageUrl
                    })
                ]
            }),
            !lastItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                color: theme/* default.color.gray40 */.Z.color.gray40
            })
        ]
    });
};
/* harmony default export */ var components_NonBenefitSearchDoctorItem = (NonBenefitSearchDoctorItem);
var EmptyDoctorItem = function(param) {
    var cheapestPrice = param.cheapestPrice, hospitalAddress = param.hospitalAddress, profileImageUrl = param.profileImageUrl, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NonBenefitDoctorItemWrapper, {
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorInfoWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorNameWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorEmptyTitle, {
                                children: "앱에서 상세 정보 확인 가능"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                name: "chevron_right",
                                color: theme/* default.color.gray300 */.Z.color.gray300,
                                size: 24,
                                filled: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorMedicinePriceWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorMedicinePrice, {
                                cheapest: true,
                                children: [
                                    (0,format/* formatPriceComma */.dM)(cheapestPrice),
                                    "원"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoctorMedicinePriceCheepWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                        name: "local_offer",
                                        size: 14,
                                        filled: true,
                                        color: theme/* default.color.primary700 */.Z.color.primary700
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorMedicinePriceCheap, {
                                        children: "닥터나우 최저가"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorAddress, {
                        children: hospitalAddress
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorDepartmentWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorVideoCall, {
                            children: "영상진료"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DoctorProfileImage, {
                src: profileImageUrl
            })
        ]
    });
};
NonBenefitSearchDoctorItem.Empty = EmptyDoctorItem;
var NonBenefitDoctorItemWrapper = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-1e5e11ed-0"
})(NonBenefitSearchDoctorItem_templateObject());
var DoctorInfoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1e5e11ed-1"
})(NonBenefitSearchDoctorItem_templateObject1());
var DoctorNameWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1e5e11ed-2"
})(NonBenefitSearchDoctorItem_templateObject2());
var DoctorName = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-1e5e11ed-3"
})(NonBenefitSearchDoctorItem_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.typography.UI16SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray600;
});
var DoctorHospitalName = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-1e5e11ed-4"
})(NonBenefitSearchDoctorItem_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.typography.UI13M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray300;
});
var DoctorMedicinePriceWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1e5e11ed-5"
})(NonBenefitSearchDoctorItem_templateObject5());
var DoctorMedicinePrice = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-1e5e11ed-6"
})(NonBenefitSearchDoctorItem_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.typography.UI18SB;
}, function(param) {
    var theme = param.theme, cheapest = param.cheapest;
    return cheapest ? theme.color.primary700 : theme.color.gray700;
});
var DoctorMedicinePriceCheepWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1e5e11ed-7"
})(NonBenefitSearchDoctorItem_templateObject7());
var DoctorMedicinePriceCheap = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-1e5e11ed-8"
})(NonBenefitSearchDoctorItem_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.typography.UI12SB;
}, function(param) {
    var theme = param.theme;
    return theme.color.primary700;
});
var DoctorAddress = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-1e5e11ed-9"
})(NonBenefitSearchDoctorItem_templateObject9(), function(param) {
    var theme = param.theme;
    return theme.typography.UI12M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray300;
});
var DoctorDepartmentWrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-1e5e11ed-10"
})(_templateObject10());
var DoctorDepartment = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-1e5e11ed-11"
})(_templateObject12(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject11(), theme.typography.UI12M, theme.color.blue600, theme.color.blue100);
});
var DoctorVideoCall = (0,styled_components_browser_esm/* default */.ZP)(DoctorDepartment).withConfig({
    componentId: "sc-1e5e11ed-12"
})(_templateObject14(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject13(), theme.color.gray300, theme.color.gray30);
});
var DoctorProfileImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1e5e11ed-13"
})(_templateObject15(), function(props) {
    return props.src;
});
var DoctorEmptyTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-1e5e11ed-14"
})(_templateObject17(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject16(), theme.typography.UI16SB, theme.color.gray300);
});

;// CONCATENATED MODULE: ./src/components/templates/nonBenefit/home/components/NonBenefitSearchDoctorList.tsx

function NonBenefitSearchDoctorList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 20px;\n"
    ]);
    NonBenefitSearchDoctorList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var NonBenefitSearchDoctorList = function(param) {
    var list = param.list, ListEmptyComponent = param.ListEmptyComponent, renderItem = param.renderItem;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NonBenefitDoctorListWrapper, {
        children: list.length > 0 ? list.map(function(doctor, i) {
            return renderItem(doctor, i === list.length - 1);
        }) : ListEmptyComponent
    });
};
/* harmony default export */ var components_NonBenefitSearchDoctorList = (NonBenefitSearchDoctorList);
var NonBenefitDoctorListWrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-75544517-0"
})(NonBenefitSearchDoctorList_templateObject());

;// CONCATENATED MODULE: ./src/components/templates/nonBenefit/home/components/NonBenefitTotalSummaryTable.tsx

function NonBenefitTotalSummaryTable_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px 24px;\n"
    ]);
    NonBenefitTotalSummaryTable_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NonBenefitTotalSummaryTable_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    NonBenefitTotalSummaryTable_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NonBenefitTotalSummaryTable_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  width: 100%;\n"
    ]);
    NonBenefitTotalSummaryTable_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NonBenefitTotalSummaryTable_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    border: 1px solid ",
        ";\n    background-color: ",
        ";\n    color: ",
        ";\n  "
    ]);
    NonBenefitTotalSummaryTable_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NonBenefitTotalSummaryTable_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  height: 32px;\n  ",
        "\n"
    ]);
    NonBenefitTotalSummaryTable_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NonBenefitTotalSummaryTable_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    border: 1px solid ",
        ";\n    background-color: ",
        ";\n    color: ",
        ";\n    white-space: ",
        ";\n    height: ",
        "px;\n    text-align: center;\n  "
    ]);
    NonBenefitTotalSummaryTable_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function NonBenefitTotalSummaryTable_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  ",
        "\n"
    ]);
    NonBenefitTotalSummaryTable_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var NonBenefitTotalSummaryTable = function(param) {
    var nonBenefitPriceTotalSummary = param.nonBenefitPriceTotalSummary, selectedAddressTitle = param.selectedAddressTitle, selectedMedicine = param.selectedMedicine;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryTableWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryTable, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryTableRow, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryTableHead, {
                                children: "가격비교"
                            }),
                            selectedMedicine.units.map(function(unit) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryTableHead, {
                                    children: [
                                        unit.unitDisplayName,
                                        " 처방"
                                    ]
                                }, "unit-".concat(unit.id));
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryTableRow, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryTableData, {
                                    children: "".concat(selectedAddressTitle, " \n최저가")
                                }),
                                nonBenefitPriceTotalSummary.regionSummaries.map(function(regionSummary) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryTableData, {
                                        cheapest: true,
                                        children: [
                                            (0,format/* formatPriceComma */.dM)(regionSummary.minPrice),
                                            "원"
                                        ]
                                    }, "region-min-".concat(regionSummary.unitDisplayName));
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryTableRow, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryTableData, {
                                    children: "".concat(selectedAddressTitle, " \n평균가")
                                }),
                                nonBenefitPriceTotalSummary.regionSummaries.map(function(regionSummary) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryTableData, {
                                        children: [
                                            (0,format/* formatPriceComma */.dM)(regionSummary.averagePrice),
                                            "원"
                                        ]
                                    }, "region-avg-".concat(regionSummary.unitDisplayName));
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryTableRow, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryTableData, {
                                    children: "전국 \n평균가"
                                }),
                                nonBenefitPriceTotalSummary.nationalSummaries.map(function(nationalSummary) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryTableData, {
                                        children: [
                                            (0,format/* formatPriceComma */.dM)(nationalSummary.averagePrice),
                                            "원"
                                        ]
                                    }, "national-avg-".concat(nationalSummary.unitDisplayName));
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_NonBenefitTotalSummaryTable = (NonBenefitTotalSummaryTable);
var SummaryTableWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8921d993-0"
})(NonBenefitTotalSummaryTable_templateObject());
var SummaryTable = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-8921d993-1"
})(NonBenefitTotalSummaryTable_templateObject1());
var SummaryTableRow = styled_components_browser_esm/* default.tr.withConfig */.ZP.tr.withConfig({
    componentId: "sc-8921d993-2"
})(NonBenefitTotalSummaryTable_templateObject2());
var SummaryTableHead = styled_components_browser_esm/* default.th.withConfig */.ZP.th.withConfig({
    componentId: "sc-8921d993-3"
})(NonBenefitTotalSummaryTable_templateObject4(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitTotalSummaryTable_templateObject3(), theme.typography.UI15R, theme.color.gray100, theme.color.gray20, theme.color.gray500);
});
var SummaryTableData = styled_components_browser_esm/* default.td.withConfig */.ZP.td.withConfig({
    componentId: "sc-8921d993-4"
})(NonBenefitTotalSummaryTable_templateObject6(), function(param) {
    var theme = param.theme, cheapest = param.cheapest;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitTotalSummaryTable_templateObject5(), theme.typography.UI15R, theme.color.gray100, theme.color.white, cheapest ? theme.color.primary600 : theme.color.gray500, theme.client.isMobile ? "pre-line" : "normal", theme.client.isMobile ? 48 : 32);
});

// EXTERNAL MODULE: ./src/components/templates/nonBenefit/home/components/RelatedKeywordContentList.tsx
var RelatedKeywordContentList = __webpack_require__(34785);
// EXTERNAL MODULE: ./src/components/templates/nonBenefit/home/components/SearchAddressFilterModal.tsx
var SearchAddressFilterModal = __webpack_require__(8457);
;// CONCATENATED MODULE: ./src/components/templates/nonBenefit/home/components/SearchBar.tsx

function SearchBar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  align-items: center;\n  padding: 16px 12px;\n  height: 48px;\n  border-radius: 8px;\n  background-color: ",
        ";\n  cursor: pointer;\n  & > p {\n    ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    SearchBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var SearchBar = function(props) {
    var title = props.title, onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchBarWrapper, {
        role: "button",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                name: "expand_more",
                size: 24,
                color: theme/* default.color.gray900 */.Z.color.gray900
            })
        ]
    });
};
/* harmony default export */ var components_SearchBar = (SearchBar);
var SearchBarWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ac50b0fe-0"
})(SearchBar_templateObject(), function(param) {
    var theme = param.theme;
    return theme.color.gray40;
}, function(param) {
    var theme = param.theme;
    return theme.typography.UI16R;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray900;
});

// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
;// CONCATENATED MODULE: ./src/components/templates/nonBenefit/home/NonBenefitHomeTemplate.tsx


function NonBenefitHomeTemplate_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n"
    ]);
    NonBenefitHomeTemplate_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: ",
        "px 24px;\n  "
    ]);
    NonBenefitHomeTemplate_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 32px;\n  justify-content: center;\n"
    ]);
    NonBenefitHomeTemplate_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n  "
    ]);
    NonBenefitHomeTemplate_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NonBenefitHomeTemplate_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        ";\n    color: ",
        ";\n    white-space: pre-line;\n  "
    ]);
    NonBenefitHomeTemplate_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NonBenefitHomeTemplate_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 0 24px;\n  gap: 16px;\n  margin-bottom: 20px;\n"
    ]);
    NonBenefitHomeTemplate_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    background-color: ",
        ";\n  "
    ]);
    NonBenefitHomeTemplate_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  padding: 0 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 56px;\n  width: 100%;\n"
    ]);
    NonBenefitHomeTemplate_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n  "
    ]);
    NonBenefitHomeTemplate_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  height: 48px;\n  border-radius: 12px;\n"
    ]);
    NonBenefitHomeTemplate_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-bottom: 1px solid ",
        ";\n  "
    ]);
    NonBenefitHomeTemplate_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NonBenefitHomeTemplate_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-bottom: 1px solid ",
        ";\n  "
    ]);
    NonBenefitHomeTemplate_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n\n  margin-top: 40px;\n  ",
        "\n"
    ]);
    NonBenefitHomeTemplate_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-bottom: 1px solid ",
        ";\n  "
    ]);
    NonBenefitHomeTemplate_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function NonBenefitHomeTemplate_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NonBenefitHomeTemplate_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-bottom: 1px solid ",
        ";\n  "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: ",
        ";\n    align-items: ",
        ";\n    justify-content: ",
        ";\n  "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  padding: 0 24px;\n  margin-bottom: 40px;\n  gap: 52px;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    white-space: pre-line;\n  "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    white-space: pre-line;\n  "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 80px;\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    margin-bottom: 8px;\n  "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    margin-bottom: 4px;\n  "
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n  "
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: center;\n    ",
        "\n    color: ",
        ";\n    margin-bottom: 12px;\n    white-space: ",
        ";\n  "
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 0;\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 24px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: pre-line;\n"
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 24px;\n  margin-bottom: 42px;\n"
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n  "
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject49 = function _templateObject49() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject50 = function _templateObject50() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject51 = function _templateObject51() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n  "
    ]);
    _templateObject52 = function _templateObject52() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px 24px;\n  ",
        "\n"
    ]);
    _templateObject53 = function _templateObject53() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 20px;\n  padding: 0 24px;\n  margin-bottom: 40px;\n"
    ]);
    _templateObject54 = function _templateObject54() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    background-color: ",
        ";\n  "
    ]);
    _templateObject55 = function _templateObject55() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject56 = function _templateObject56() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 40px;\n"
    ]);
    _templateObject57 = function _templateObject57() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 35px 24px 0;\n"
    ]);
    _templateObject58 = function _templateObject58() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject59 = function _templateObject59() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 189px;\n  padding: 59px 24px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  margin: 0 24px;\n\n  border-radius: 12px;\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%),\n    url('https://file.doctornow.co.kr/non-benefit/non_benefit_map_thumbnail.png') lightgray 0 -0.013px / 117.448% 380.437%\n      no-repeat;\n"
    ]);
    _templateObject60 = function _templateObject60() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: center;\n\n  ",
        "\n"
    ]);
    _templateObject61 = function _templateObject61() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 40px;\n  padding: 0px 16px;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  flex-shrink: 0;\n\n  border-radius: 8px;\n  background: ",
        ";\n"
    ]);
    _templateObject62 = function _templateObject62() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject63 = function _templateObject63() {
        return data;
    };
    return data;
}




















var NonBenefitHomeTemplate = function(param) {
    var client = param.client, viewModel = param.viewModel;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBreadCrumbs/* default.Wrapper */.Z.Wrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBreadCrumbs/* default */.Z, {
                    visible: !client.isMobile,
                    breadCrumbs: viewModel.breadCrumbs
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchFilterSection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NonBenefitTitle, {
                                        children: "".concat(viewModel.selectedAddressTitle, " ").concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 최저가 가격 ").concat(viewModel.selectedMedicine.medicineName, " ").concat(viewModel.selectedMedicine.medicineDescription, " 2025")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NonBenefitDescription, {
                                        children: "닥터나우에서 ".concat(viewModel.selectedAddressTitle, " ").concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방 성지 병원의 진료 가격을 비교한 결과,\n 최저가 ").concat(viewModel.selectedMedicine.treatment.name, " 진료비는 ").concat((0,format/* formatPriceComma */.dM)(viewModel.selectedRegionSummary.minPrice), "원이에요.")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchBarListWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SearchBar, {
                                        title: "".concat(viewModel.selectedAddressTitle),
                                        onClick: viewModel.onOpenSearchAddressFilterModal
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SearchBar, {
                                        title: "".concat(viewModel.selectedMedicine.medicineName),
                                        onClick: viewModel.onOpenMedicineFilterModal
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SearchBar, {
                                        title: "".concat(viewModel.selectedMedicineUnit.unitDisplayName),
                                        onClick: viewModel.onOpenMedicineUnitFilterModal
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        height: "16px",
                        color: theme/* default.color.gray30 */.Z.color.gray30
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchSummarySection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTag/* default */.Z, {
                                href: "".concat(common/* ROUTES.NON_BENEFIT.MAP.path */.Z6.NON_BENEFIT.MAP.path, "?diagnosisTypeId=").concat((ref = viewModel.selectedMedicine.treatment) === null || ref === void 0 ? void 0 : ref.id, "&treatmentMedicineId=").concat(viewModel.selectedMedicine.id),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MapBannerWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MapBannerText, {
                                            children: "근처 최저가 약국을 찾고 싶다면?"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MapBannerButton, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MapBannerButtonLabel, {
                                                children: [
                                                    viewModel.selectedMedicine.treatmentProductMedicineName,
                                                    " 최저가 약국 찾기",
                                                    " "
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchSummaryWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchSummaryInfoWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchSummaryTitle, {
                                                children: "".concat(viewModel.selectedAddressTitle, " ").concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방 \n 최저가 진료 가격은\n ").concat(viewModel.priceDisplayGapText)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchSummaryDescription, {
                                                children: "닥터나우에서 조회된 ".concat(viewModel.selectedAddressTitle, " ").concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방\n성지 병원의 ").concat(viewModel.selectedMedicineUnit.unitDisplayName, " 진료 가격이에요.")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchSummaryPricesWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryPriceWrapper, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryPriceMinTitle, {
                                                        children: "최저가"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryPriceMin, {
                                                        children: [
                                                            (0,format/* formatPriceComma */.dM)(viewModel.selectedRegionSummary.minPrice),
                                                            "원"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryExcludeMedicine, {
                                                        children: "약 가격 미포함"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryPriceWrapper, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryPriceTitle, {
                                                        children: "평균가"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SummaryPrice, {
                                                        children: [
                                                            (0,format/* formatPriceComma */.dM)(viewModel.selectedRegionSummary.averagePrice),
                                                            "원"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SummaryExcludeMedicine, {
                                                        children: "약 가격 미포함"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        height: "16px",
                        color: theme/* default.color.gray30 */.Z.color.gray30
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchDoctorSection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDoctorHeader, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchDoctorTitleWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDoctorTitle, {
                                            children: "".concat(viewModel.selectedAddressTitle, " 성지 병원\n").concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방 비대면 진료 가격 정보")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDoctorDescription, {
                                            children: "".concat(viewModel.selectedAddressTitle, " ").concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 성지 병원의 ").concat(viewModel.selectedMedicineUnit.unitDisplayName, " 비대면 진료 가격이에요.\n닥터나우에서는 ").concat(viewModel.selectedMedicine.treatmentProductMedicineName, "을 전화로 편하게 받을 수 있어요.")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NonBenefitSearchDoctorList, {
                                list: viewModel.nonBenefitDoctors,
                                ListEmptyComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NonBenefitSearchDoctorItem.Empty, {
                                    hospitalAddress: viewModel.selectedFullAddressTitle,
                                    cheapestPrice: viewModel.selectedRegionSummary.minPrice,
                                    profileImageUrl: "https://file.doctornow.co.kr/doctors/default_profile.png",
                                    onClick: viewModel.onOpenDiagnosisAppInstallBottomSheet
                                }),
                                renderItem: function(doctor, lastItem) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NonBenefitSearchDoctorItem, {
                                        doctor: doctor,
                                        cheapestPrice: viewModel.selectedRegionSummary.minPrice,
                                        treatmentMedicineUnitId: viewModel.selectedMedicineUnit.id,
                                        lastItem: lastItem,
                                        onClick: function() {
                                            return viewModel.onClickDoctor(doctor, viewModel.selectedMedicine);
                                        }
                                    }, "doctor-".concat(doctor.doctorId));
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDoctorListButtonWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDoctorListButton, {
                                    onClick: viewModel.onOpenDiagnosisAppInstallBottomSheet,
                                    children: "".concat(viewModel.selectedAddressTitle, " ").concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 성지 병원 보러가기")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        height: "16px",
                        color: theme/* default.color.gray30 */.Z.color.gray30
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchTotalSummarySection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchTotalSummaryHeader, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchTotalSummaryTitleWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchTotalSummaryTitle, {
                                            children: "".concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방 성지 진료 가격 비교 (").concat(viewModel.selectedMedicine.medicineProductName, ")")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchTotalSummaryDescriptionWrapper, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchTotalSummaryDescription, {
                                                    children: "".concat(viewModel.selectedAddressTitle, " ").concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방 성지 병원의 가격 비교예요.")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchTotalSummaryDescription, {
                                                    children: "닥터나우 앱에서 ".concat(viewModel.selectedAddressTitle, "과(와) 전국의 ").concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방 가격을 비교하고 비대면 진료 받아보세요.")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchTotalSummarySubTitle, {
                                children: "".concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방 비대면 진료 가격")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NonBenefitTotalSummaryTable, {
                                nonBenefitPriceTotalSummary: viewModel.nonBenefitPriceTotalSummary,
                                selectedAddressTitle: viewModel.selectedAddressTitle,
                                selectedMedicine: viewModel.selectedMedicine
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchTotalSummaryButtonWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchTotalSummaryButton, {
                                    onClick: viewModel.onOpenDiagnosisAppInstallBottomSheet,
                                    children: "".concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방 최저가를 확인하고 싶다면?")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        height: "16px",
                        color: theme/* default.color.gray30 */.Z.color.gray30
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineSection, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedKeywordContentList/* default */.Z, {
                            list: viewModel.faqs,
                            title: "".concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방 자주 묻는 질문"),
                            renderItem: function(faq, isLast) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTag/* default */.Z, {
                                    href: "".concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(faq.magazinePid),
                                    onClickNavigateToScreen: function() {
                                        return viewModel.onClickRelatedFaq(faq.magazinePid);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListMagazineLine/* default */.Z, {
                                        magazine: {
                                            title: faq.title,
                                            mobileTitle: faq.title,
                                            image: "",
                                            date: faq.createdDate,
                                            magazinePid: faq.magazinePid,
                                            description: faq.description,
                                            mobileDescription: faq.mobileDescription
                                        },
                                        isLast: isLast
                                    })
                                }, "faq-".concat(faq.magazinePid));
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        height: "16px",
                        color: theme/* default.color.gray30 */.Z.color.gray30
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineSection, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedKeywordContentList/* default */.Z, {
                            list: viewModel.magazines,
                            title: "".concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방 건강 매거진"),
                            renderItem: function(magazine, isLast) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTag/* default */.Z, {
                                    href: "".concat(common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazine.magazinePid),
                                    onClickNavigateToScreen: function() {
                                        return viewModel.onClickRelatedMagazine(magazine.magazinePid);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListMagazineLine/* default */.Z, {
                                        magazine: {
                                            title: magazine.title,
                                            mobileTitle: magazine.title,
                                            image: magazine.titleImageUrl,
                                            date: magazine.createdDate,
                                            magazinePid: magazine.magazinePid,
                                            description: magazine.description,
                                            mobileDescription: magazine.mobileDescription
                                        },
                                        isLast: isLast
                                    })
                                }, "magazine-".concat(magazine.magazinePid));
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        height: "16px",
                        color: theme/* default.color.gray30 */.Z.color.gray30
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MagazineSection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedKeywordContentList/* default */.Z, {
                                list: viewModel.qnas,
                                title: "".concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방 의료진 상담"),
                                renderItem: function(qna, isLast) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkTag/* default */.Z, {
                                        href: "".concat(common/* ROUTES.QNA.DETAIL.path */.Z6.QNA.DETAIL.path, "/").concat(qna.question.questionPid),
                                        onClickNavigateToScreen: function() {
                                            viewModel.onClickRelatedQuestion(qna.question.questionPid);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedQuestionItem/* default */.Z, {
                                            onClickRelatedQna: function() {
                                                viewModel.onClickRelatedQuestion(qna.question.questionPid);
                                            },
                                            questionCard: qna,
                                            isLast: isLast
                                        })
                                    }, "content_related_qna_".concat(qna.question.questionPid));
                                }
                            }),
                            viewModel.isEnableQnaPagination && /*#__PURE__*/ (0,jsx_runtime.jsx)(QnaMoreButtonWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QnaMoreButton, {
                                    onClick: viewModel.onClickNextQna,
                                    children: "".concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방 의료진 상담 더 보기")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        height: "16px",
                        color: theme/* default.color.gray30 */.Z.color.gray30
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineSection, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NonBenefitCategoryInformation, {
                            selectedMedicine: viewModel.selectedMedicine
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FixedButton/* default */.ZP, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FixedButtonWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchSummaryNotice, {
                                    children: "".concat(viewModel.selectedMedicine.treatment.name, " 비대면 진료 가능해요!")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FixedButton/* default.Button */.ZP.Button, {
                                    text: "".concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 처방받기"),
                                    onClick: viewModel.onOpenDiagnosisAppInstallBottomSheet
                                })
                            ]
                        })
                    })
                ]
            }),
            viewModel.isAddressFilterModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchAddressFilterModal/* default */.Z, (0,_object_spread/* default */.Z)({}, viewModel.getSearchAddressFilterModalProps()))
        ]
    });
};
/* harmony default export */ var home_NonBenefitHomeTemplate = (NonBenefitHomeTemplate);
var BreadCrumbsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b0f53e9-0"
})(NonBenefitHomeTemplate_templateObject(), function(param) {
    var _$theme = param.theme;
    return _$theme.client.isMobile ? "0" : "24px 24px 16px";
});
var TitleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b0f53e9-1"
})(NonBenefitHomeTemplate_templateObject2(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitHomeTemplate_templateObject1(), _$theme.client.isMobile ? 0 : 2);
});
var NonBenefitTitle = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-2b0f53e9-2"
})(NonBenefitHomeTemplate_templateObject4(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitHomeTemplate_templateObject3(), _$theme.typography.UI22SB, _$theme.color.gray900);
});
var NonBenefitDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-2b0f53e9-3"
})(NonBenefitHomeTemplate_templateObject6(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitHomeTemplate_templateObject5(), _$theme.typography.UI15R, _$theme.color.gray500);
});
var SearchBarListWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b0f53e9-4"
})(NonBenefitHomeTemplate_templateObject7());
var SearchButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-2b0f53e9-5"
})(NonBenefitHomeTemplate_templateObject9(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitHomeTemplate_templateObject8(), _$theme.typography.UI17SB, _$theme.color.white, _$theme.color.gray700);
});
var SearchLargeButton = (0,styled_components_browser_esm/* default */.ZP)(SearchButton).withConfig({
    componentId: "sc-2b0f53e9-6"
})(NonBenefitHomeTemplate_templateObject11(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitHomeTemplate_templateObject10(), _$theme.typography.UI16SB);
});
var SearchFilterSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-2b0f53e9-7"
})(NonBenefitHomeTemplate_templateObject13(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitHomeTemplate_templateObject12(), _$theme.color.gray50);
});
var SearchSummarySection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-2b0f53e9-8"
})(NonBenefitHomeTemplate_templateObject15(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitHomeTemplate_templateObject14(), _$theme.color.gray50);
});
var SearchDoctorSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-2b0f53e9-9"
})(NonBenefitHomeTemplate_templateObject17(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitHomeTemplate_templateObject16(), _$theme.color.gray50);
});
var SearchTotalSummarySection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-2b0f53e9-10"
})(_templateObject19(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject18(), _$theme.color.gray50);
});
var SearchSummaryWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b0f53e9-11"
})(_templateObject21(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject20(), _$theme.client.isMobile ? "column" : "row", _$theme.client.isMobile ? "flex-start" : "center", _$theme.client.isMobile ? "flex-start" : "space-between");
});
var SearchSummaryInfoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b0f53e9-12"
})(_templateObject22());
var SearchSummaryTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-2b0f53e9-13"
})(_templateObject24(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject23(), _$theme.typography.UI22SB, _$theme.color.gray700);
});
var SearchSummaryDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-2b0f53e9-14"
})(_templateObject26(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject25(), _$theme.typography.UI15R, _$theme.color.gray500);
});
var SearchSummaryPricesWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b0f53e9-15"
})(_templateObject27());
var SummaryPriceWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b0f53e9-16"
})(_templateObject28());
var SummaryPriceTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-2b0f53e9-17"
})(_templateObject30(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject29(), _$theme.typography.UI17SB, _$theme.color.gray600);
});
var SummaryPriceMinTitle = (0,styled_components_browser_esm/* default */.ZP)(SummaryPriceTitle).withConfig({
    componentId: "sc-2b0f53e9-18"
})(_templateObject31(), function(param) {
    var _$theme = param.theme;
    return _$theme.color.primary600;
});
var SummaryPrice = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-2b0f53e9-19"
})(_templateObject33(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject32(), _$theme.typography.UI26SB, _$theme.color.gray800);
});
var SummaryPriceMin = (0,styled_components_browser_esm/* default */.ZP)(SummaryPrice).withConfig({
    componentId: "sc-2b0f53e9-20"
})(_templateObject34(), function(param) {
    var _$theme = param.theme;
    return _$theme.color.primary700;
});
var SummaryExcludeMedicine = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-2b0f53e9-21"
})(_templateObject36(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject35(), _$theme.typography.UI14R, _$theme.color.gray300);
});
var SearchSummaryNotice = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-2b0f53e9-22"
})(_templateObject38(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject37(), _$theme.typography.UI16M, _$theme.color.gray700, _$theme.client.isMobile ? "pre-line" : "normal");
});
var FixedButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b0f53e9-23"
})(_templateObject39());
var SearchDoctorHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b0f53e9-24"
})(_templateObject40());
var SearchDoctorTitleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b0f53e9-25"
})(_templateObject41());
var SearchDoctorTitle = (0,styled_components_browser_esm/* default */.ZP)(SearchSummaryTitle).withConfig({
    componentId: "sc-2b0f53e9-26"
})(_templateObject42());
var SearchDoctorDescription = (0,styled_components_browser_esm/* default */.ZP)(SearchSummaryDescription).withConfig({
    componentId: "sc-2b0f53e9-27"
})(_templateObject43());
var SearchDoctorListButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b0f53e9-28"
})(_templateObject44());
var SearchDoctorListButton = (0,styled_components_browser_esm/* default */.ZP)(SearchLargeButton).withConfig({
    componentId: "sc-2b0f53e9-29"
})(_templateObject46(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject45(), _$theme.color.gray600, _$theme.color.white, _$theme.color.gray100);
});
var SearchTotalSummaryHeader = (0,styled_components_browser_esm/* default */.ZP)(SearchDoctorHeader).withConfig({
    componentId: "sc-2b0f53e9-30"
})(_templateObject47());
var SearchTotalSummaryTitleWrapper = (0,styled_components_browser_esm/* default */.ZP)(SearchDoctorTitleWrapper).withConfig({
    componentId: "sc-2b0f53e9-31"
})(_templateObject48());
var SearchTotalSummaryTitle = (0,styled_components_browser_esm/* default */.ZP)(SearchDoctorTitle).withConfig({
    componentId: "sc-2b0f53e9-32"
})(_templateObject49());
var SearchTotalSummaryDescriptionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b0f53e9-33"
})(_templateObject50());
var SearchTotalSummaryDescription = (0,styled_components_browser_esm/* default */.ZP)(SearchDoctorDescription).withConfig({
    componentId: "sc-2b0f53e9-34"
})(_templateObject51());
var SearchTotalSummarySubTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-2b0f53e9-35"
})(_templateObject53(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject52(), _$theme.typography.UI17SB, _$theme.color.gray600);
});
var SearchTotalSummaryButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b0f53e9-36"
})(_templateObject54());
var SearchTotalSummaryButton = (0,styled_components_browser_esm/* default */.ZP)(SearchLargeButton).withConfig({
    componentId: "sc-2b0f53e9-37"
})(_templateObject56(), function(param) {
    var _$theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject55(), _$theme.color.primary800, _$theme.color.primary100);
});
var MagazineSection = (0,styled_components_browser_esm/* default */.ZP)(SearchDoctorSection).withConfig({
    componentId: "sc-2b0f53e9-38"
})(_templateObject57());
var QnaMoreButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b0f53e9-39"
})(_templateObject58());
var QnaMoreButton = (0,styled_components_browser_esm/* default */.ZP)(SearchDoctorListButton).withConfig({
    componentId: "sc-2b0f53e9-40"
})(_templateObject59());
var MapBannerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b0f53e9-41"
})(_templateObject60());
var MapBannerText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b0f53e9-42"
})(_templateObject61(), function(param) {
    var _$theme = param.theme;
    return _$theme.color.white;
}, function(param) {
    var _$theme = param.theme;
    return _$theme.typography.UI20SB;
});
var MapBannerButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b0f53e9-43"
})(_templateObject62(), function(param) {
    var _$theme = param.theme;
    return _$theme.color.primary600;
});
var MapBannerButtonLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b0f53e9-44"
})(_templateObject63(), theme/* default.color.white */.Z.color.white, function(param) {
    var _$theme = param.theme;
    return _$theme.typography.UI14SB;
});

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(85244);
// EXTERNAL MODULE: ../../node_modules/lodash/lodash.js
var lodash = __webpack_require__(76635);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./src/components/templates/nonBenefit/home/components/DiagnosisAppInstallBottomSheet.tsx
var DiagnosisAppInstallBottomSheet = __webpack_require__(29305);
;// CONCATENATED MODULE: ./src/components/templates/nonBenefit/home/components/NonBenefitFilterModal.tsx

function NonBenefitFilterModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: ",
        "px;\n    background-color: ",
        ";\n  "
    ]);
    NonBenefitFilterModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NonBenefitFilterModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  border-radius:24px;\n  padding: 24px 0 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"
    ]);
    NonBenefitFilterModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NonBenefitFilterModal_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    color: ",
        ";\n    padding: 0 24px;\n  "
    ]);
    NonBenefitFilterModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NonBenefitFilterModal_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    NonBenefitFilterModal_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NonBenefitFilterModal_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    NonBenefitFilterModal_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function NonBenefitFilterModal_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    & > p {\n      ",
        "\n      color: ",
        ";\n    }\n  "
    ]);
    NonBenefitFilterModal_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function NonBenefitFilterModal_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  height: 56px;\n  padding: 12px 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n"
    ]);
    NonBenefitFilterModal_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var NonBenefitFilterModal = function(props) {
    var title = props.title, list = props.list, selectedItem = props.selectedItem, onClick = props.onClick, getItemName = props.getItemName;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterModalWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterModalTitle, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterList, {
                children: list.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Filter, {
                        onClick: function() {
                            return onClick(item);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: getItemName(item)
                            }),
                            selectedItem.id === item.id && /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                name: "check",
                                size: 32,
                                color: theme/* default.color.primary500 */.Z.color.primary500
                            })
                        ]
                    }, "filter-".concat(getItemName(item)));
                })
            })
        ]
    });
};
/* harmony default export */ var components_NonBenefitFilterModal = (NonBenefitFilterModal);
var FilterModalWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4b444afd-0"
})(NonBenefitFilterModal_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitFilterModal_templateObject(), theme.client.isMobile ? 300 : 560, theme.color.white);
});
var FilterModalTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-4b444afd-1"
})(NonBenefitFilterModal_templateObject3(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitFilterModal_templateObject2(), theme.typography.UI20SB, theme.color.gray800);
});
var FilterList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-4b444afd-2"
})(NonBenefitFilterModal_templateObject4());
var Filter = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-4b444afd-3"
})(NonBenefitFilterModal_templateObject6(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(NonBenefitFilterModal_templateObject5(), theme.typography.UI16SB, theme.color.gray700);
});

// EXTERNAL MODULE: ./src/hooks/hospital/search/useSearchKoreaAddressV2.ts
var useSearchKoreaAddressV2 = __webpack_require__(75527);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(22710);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./src/hooks/nonBenefit/nonBenefit.gql.impl.tsx
var nonBenefit_gql_impl = __webpack_require__(96159);
// EXTERNAL MODULE: ./src/models/nonBenefit/index.ts
var models_nonBenefit = __webpack_require__(83018);
;// CONCATENATED MODULE: ./src/parsers/nonBenefit/index.ts



var parseNonBenefitMedicinesForSeo = function(data) {
    var medicines = data.nonBenefitMedicinesForSeo.map(function(nonBenefitMedicine) {
        var _medicineDescription;
        return new models_nonBenefit/* NonBenefitMedicine */.Vp({
            id: nonBenefitMedicine.id,
            medicineName: nonBenefitMedicine.medicineName,
            medicineDescription: (_medicineDescription = nonBenefitMedicine.medicineDescription) !== null && _medicineDescription !== void 0 ? _medicineDescription : "",
            units: nonBenefitMedicine.units.map(function(unit) {
                return {
                    id: unit.id,
                    unit: unit.unit,
                    unitType: unit.unitType,
                    unitTypeDisplayName: unit.unitTypeDisplayName
                };
            }),
            treatment: {
                id: nonBenefitMedicine.treatment.id,
                name: nonBenefitMedicine.treatment.name,
                isBenefit: nonBenefitMedicine.treatment.isBenefit,
                categoryId: nonBenefitMedicine.treatment.categoryId
            }
        });
    });
    return new models_nonBenefit/* NonBenefitMedicines */._x(medicines);
};
var parseNonBenefitPriceTotalSummary = function(data) {
    var nationalSummaries = data.nonBenefitPriceTotalSummary.nationalSummaries.map(function(nationalSummary) {
        return {
            averagePrice: nationalSummary.averagePrice,
            minPrice: nationalSummary.minPrice,
            treatmentMedicineUnitId: nationalSummary.treatmentMedicineUnitId,
            unitDisplayName: nationalSummary.unitDisplayName,
            unitTypeDisplayName: nationalSummary.unitTypeDisplayName
        };
    });
    var regionSummaries = data.nonBenefitPriceTotalSummary.regionSummaries.map(function(regionSummary) {
        return {
            averagePrice: regionSummary.averagePrice,
            minPrice: regionSummary.minPrice,
            treatmentMedicineUnitId: regionSummary.treatmentMedicineUnitId,
            unitDisplayName: regionSummary.unitDisplayName,
            unitTypeDisplayName: regionSummary.unitTypeDisplayName
        };
    });
    return new models_nonBenefit/* NonBenefitPriceSummary */.QG({
        regionSummaries: regionSummaries,
        nationalSummaries: nationalSummaries
    });
};
var parseSearchNonF2fDoctorsForSeoByUser = function(data) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
        pages: data.pages.map(function(page) {
            return page.searchNonF2fDoctorsForSeoByUser.map(function(doctor) {
                var ref;
                var _jibunAddress, _roadAddress, _siGunGuName, ref1;
                return new models_nonBenefit/* NonF2fDoctor */.ud({
                    doctorId: doctor.doctorId,
                    name: doctor.name,
                    medicineType: doctor.medicineType,
                    hospitalName: doctor.hospital.hospitalName,
                    publicId: doctor.publicId,
                    hospitalAddress: {
                        jibunAddress: (_jibunAddress = doctor.hospital.hospitalAddress.jibunAddress) !== null && _jibunAddress !== void 0 ? _jibunAddress : "",
                        roadAddress: (_roadAddress = doctor.hospital.hospitalAddress.roadAddress) !== null && _roadAddress !== void 0 ? _roadAddress : "",
                        regionByDepth: {
                            siDoName: doctor.hospital.hospitalAddress.regionByDepth.siDoName,
                            siGunGuName: (_siGunGuName = doctor.hospital.hospitalAddress.regionByDepth.siGunGuName) !== null && _siGunGuName !== void 0 ? _siGunGuName : "",
                            legalEupMyeonDongName: doctor.hospital.hospitalAddress.regionByDepth.legalEupMyeonDongName
                        }
                    },
                    nonBenefitTreatments: doctor.nonBenefitTreatmentsV2.map(function(treatment) {
                        return {
                            nonBenefitTreatmentUnitInfos: treatment.nonBenefitTreatmentUnitInfos.map(function(unitInfo) {
                                return {
                                    originalPrice: unitInfo.originalPrice,
                                    unitDisplayName: unitInfo.unitDisplayName,
                                    treatmentMedicineUnitId: unitInfo.treatmentMedicineUnitId
                                };
                            })
                        };
                    }),
                    profileImageUrl: (ref1 = (ref = doctor.detail) === null || ref === void 0 ? void 0 : ref.profileImageUrl) !== null && ref1 !== void 0 ? ref1 : "",
                    readyForVideoCall: doctor.readyForVideoCall,
                    departments: doctor.departments
                });
            });
        })
    });
};

;// CONCATENATED MODULE: ./src/hooks/nonBenefit/useNonBenefitMedicinesForSeo.ts





var useNonBenefitMedicinesForSeo = function() {
    var ref = (0,nonBenefit_gql_impl/* useNonBenefitMedicinesForSeoQuery */.Ee)({}, {
        select: parseNonBenefitMedicinesForSeo,
        refetchOnMount: false
    }), tmp = ref.data, nonBenefitMedicines = tmp === void 0 ? new models_nonBenefit/* NonBenefitMedicines */._x([]) : tmp, isLoading = ref.isLoading;
    return {
        isLoading: isLoading,
        nonBenefitMedicines: nonBenefitMedicines
    };
};
var fetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient) {
        var response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.fetchQuery(nonBenefit_gql_impl/* useNonBenefitMedicinesForSeoQuery.getKey */.Ee.getKey({}), nonBenefit_gql_impl/* useNonBenefitMedicinesForSeoQuery.fetcher */.Ee.fetcher({}))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        parseNonBenefitMedicinesForSeo(response)
                    ];
            }
        });
    });
    return function fetchQuery(queryClient) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var nonBenefit_useNonBenefitMedicinesForSeo = (useNonBenefitMedicinesForSeo);
useNonBenefitMedicinesForSeo.fetchQuery = fetchQuery;

;// CONCATENATED MODULE: ./src/hooks/nonBenefit/useNonBenefitPriceTotalSummary.ts





var useNonBenefitPriceTotalSummary = function(treatmentMedicineId, regionCode) {
    var ref = (0,nonBenefit_gql_impl/* useNonBenefitPriceTotalSummaryQuery */.X9)({
        regionCode: regionCode,
        treatmentMedicineId: treatmentMedicineId
    }, {
        select: parseNonBenefitPriceTotalSummary
    }), tmp = ref.data, nonBenefitPriceTotalSummary = tmp === void 0 ? new models_nonBenefit/* NonBenefitPriceSummary */.QG({
        regionSummaries: [],
        nationalSummaries: []
    }) : tmp;
    return {
        nonBenefitPriceTotalSummary: nonBenefitPriceTotalSummary
    };
};
/* harmony default export */ var nonBenefit_useNonBenefitPriceTotalSummary = (useNonBenefitPriceTotalSummary);
var prefetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient, treatmentMedicineId, regionCode) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.prefetchQuery(nonBenefit_gql_impl/* useNonBenefitPriceTotalSummaryQuery.getKey */.X9.getKey({
                            regionCode: regionCode,
                            treatmentMedicineId: treatmentMedicineId
                        }), nonBenefit_gql_impl/* useNonBenefitPriceTotalSummaryQuery.fetcher */.X9.fetcher({
                            regionCode: regionCode,
                            treatmentMedicineId: treatmentMedicineId
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function prefetchQuery(queryClient, treatmentMedicineId, regionCode) {
        return _ref.apply(this, arguments);
    };
}();
useNonBenefitPriceTotalSummary.prefetchQuery = prefetchQuery;

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs + 1 modules
var useInfiniteQuery = __webpack_require__(59403);
// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
;// CONCATENATED MODULE: ./src/hooks/nonBenefit/useSearchNonF2fDoctorsForSeoByUser.ts








var useSearchNonF2fDoctorsForSeoByUser = function(request) {
    var contactType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : gql_schema/* DiagnosisContactType.NonF2F */.qn.NonF2F;
    var data = (0,useInfiniteQuery/* useInfiniteQuery */.N)(nonBenefit_gql_impl/* useSearchNonF2fDoctorsForSeoByUserQuery.getKey */.Y6.getKey({
        request: request,
        contactType: contactType
    }), function(param) {
        var pageParam = param.pageParam;
        return nonBenefit_gql_impl/* useSearchNonF2fDoctorsForSeoByUserQuery.fetcher */.Y6.fetcher({
            request: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, request), {
                page: pageParam || 1
            }),
            contactType: contactType
        })();
    }, {
        getNextPageParam: function(lastPage, allPages) {
            if (!lastPage.searchNonF2fDoctorsForSeoByUser.length || lastPage.searchNonF2fDoctorsForSeoByUser.length < request.limit) {
                return undefined;
            }
            return allPages.length + 1;
        },
        staleTime: 1000 * 60 * 5,
        select: parseSearchNonF2fDoctorsForSeoByUser
    }).data;
    var nonBenefitDoctors = (data === null || data === void 0 ? void 0 : data.pages.flatMap(function(doctor) {
        return doctor;
    })) || [];
    return {
        nonBenefitDoctors: nonBenefitDoctors
    };
};
/* harmony default export */ var nonBenefit_useSearchNonF2fDoctorsForSeoByUser = (useSearchNonF2fDoctorsForSeoByUser);
useSearchNonF2fDoctorsForSeoByUser.prefetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient, request) {
        var contactType;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    contactType = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : gql_schema/* DiagnosisContactType.NonF2F */.qn.NonF2F;
                    return [
                        4,
                        queryClient.prefetchInfiniteQuery(nonBenefit_gql_impl/* useSearchNonF2fDoctorsForSeoByUserQuery.getKey */.Y6.getKey({
                            request: request,
                            contactType: contactType
                        }), nonBenefit_gql_impl/* useSearchNonF2fDoctorsForSeoByUserQuery.fetcher */.Y6.fetcher({
                            request: request,
                            contactType: contactType
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient, request) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/hooks/search/magazine/useGetKeywordSearchMagazineInfinite.ts + 1 modules
var useGetKeywordSearchMagazineInfinite = __webpack_require__(58104);
// EXTERNAL MODULE: ./src/hooks/search/qna/useGetKeywordQuestionCardInfinite.ts + 1 modules
var useGetKeywordQuestionCardInfinite = __webpack_require__(66127);
// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
// EXTERNAL MODULE: ./src/hooks/useModal.tsx
var useModal = __webpack_require__(98266);
// EXTERNAL MODULE: ./src/types/magazine.ts
var magazine = __webpack_require__(45162);
// EXTERNAL MODULE: ./src/types/modal.ts
var modal = __webpack_require__(74701);
// EXTERNAL MODULE: ./src/utils/airbridge.ts
var airbridge = __webpack_require__(89776);
// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(74735);
;// CONCATENATED MODULE: ./src/hooks/nonBenefit/useNonBenefitHomeViewModel.tsx





















var useNonBenefitHomeViewModel = function(client) {
    var ref = (0,useCustomRouter/* default */.Z)(), router = ref.router, moveToPage = ref.moveToPage;
    var ref1 = (0,useModal/* default */.Z)(), showModal = ref1.showModal, closeModal = ref1.closeModal;
    var queries = router.query;
    var _treatmentMedicineUnitId = queries.treatmentMedicineUnitId, treatmentMedicineUnitId = _treatmentMedicineUnitId === void 0 ? "" : _treatmentMedicineUnitId, _regionCode = queries.regionCode, regionCode = _regionCode === void 0 ? "" : _regionCode;
    var breadCrumbs = [
        {
            label: "우리동네 진료 가격",
            url: common/* ROUTES.NON_BENEFIT.HOME.path */.Z6.NON_BENEFIT.HOME.path + (0,url/* addQueryString */.sC)(queries),
            logName: "non_benefit_home"
        }, 
    ];
    var ref2 = (0,react.useState)(false), isAddressFilterModalOpen = ref2[0], setIsAddressFilterModalOpen = ref2[1];
    var ref3 = (0,react.useState)(true), isEnableQnaPagination = ref3[0], setIsEnableQnaPagination = ref3[1];
    /* 비급여 목록 */ var nonBenefitMedicines = nonBenefit_useNonBenefitMedicinesForSeo().nonBenefitMedicines;
    /* 선택된 비급여 및 비급여 유닛 */ var selectedMedicine = nonBenefitMedicines.findMedicineByTreatmentMedicineUnitId(treatmentMedicineUnitId);
    var selectedMedicineUnit = nonBenefitMedicines.findMedicineUnitByTreatmentMedicineUnitId(treatmentMedicineUnitId);
    /* 비급여 가격 정보 */ var nonBenefitPriceTotalSummary = nonBenefit_useNonBenefitPriceTotalSummary(selectedMedicine.id, regionCode).nonBenefitPriceTotalSummary;
    var selectedRegionSummary = nonBenefitPriceTotalSummary.getSelectedRegionSummaryByTreatmentMedicineUnitId(treatmentMedicineUnitId);
    var priceDisplayGapText = nonBenefitPriceTotalSummary.getComparePriceDisplayGapText(treatmentMedicineUnitId);
    /* 비급여 검색 결과 의사리스트 */ var nonBenefitDoctors = nonBenefit_useSearchNonF2fDoctorsForSeoByUser({
        regionCode: regionCode,
        treatmentMedicineUnitId: treatmentMedicineUnitId,
        limit: 3,
        page: 1
    }).nonBenefitDoctors;
    /* 지역 검색 */ var queryRegion = new models_nonBenefit/* Region */.yp(regionCode);
    var ref4 = (0,useSearchKoreaAddressV2/* default */.Z)({
        siDoCode: null,
        siGunGuCode: null
    }), tmp = ref4.data, siDoList = tmp === void 0 ? [] : tmp;
    var ref5 = (0,useSearchKoreaAddressV2/* default */.Z)({
        siDoCode: queryRegion.excludeSejongSiDoRegionCode(),
        siGunGuCode: null
    }), tmp1 = ref5.data, siGunGuList = tmp1 === void 0 ? [] : tmp1;
    var ref6 = (0,useSearchKoreaAddressV2/* default */.Z)({
        siDoCode: queryRegion.regionCodes.siDoCode,
        siGunGuCode: queryRegion.excludeSejongSiGunGuRegionCode()
    }), tmp2 = ref6.data, dongList = tmp2 === void 0 ? [] : tmp2;
    /* 선택된 지역 */ var koreaAddress = new models_nonBenefit/* KoreaAddress */.cZ(siDoList, siGunGuList, dongList);
    var selectedAddressList = koreaAddress.getSelectedRegionByDepth(queryRegion);
    var selectedAddressTitle = koreaAddress.getAddressTitle(queryRegion);
    var selectedFullAddressTitle = koreaAddress.getFullAddressTitle(queryRegion);
    /* 관련 컨텐츠 및 QNA */ var ref7 = (0,useGetKeywordSearchMagazineInfinite/* default */.Z)({
        keyword: selectedMedicine.treatment.name,
        size: 7,
        contentType: magazine/* MagazineType.FAQ */.rL.FAQ
    }), faqs = ref7.magazines;
    var magazines = (0,useGetKeywordSearchMagazineInfinite/* default */.Z)({
        keyword: selectedMedicine.treatment.name,
        size: 7,
        contentType: magazine/* MagazineType.ARTICLE */.rL.ARTICLE
    }).magazines;
    var ref8 = (0,useGetKeywordQuestionCardInfinite/* default */.Z)({
        keyword: selectedMedicine.treatment.name,
        size: 5
    }), qnas = ref8.qnas, fetchSearchedQnaNextPage = ref8.fetchSearchedQnaNextPage;
    var onUpdateAddress = function(item) {
        router.replace({
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queries), {
                regionCode: item.regionCode
            })
        });
    };
    var onSelectAddress = function(item) {
        onUpdateAddress(item);
        onCloseSearchAddressFilterModal();
    };
    var selectMedicine = function(item) {
        router.replace({
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queries), {
                treatmentMedicineUnitId: item.units[0].id
            })
        });
        closeModal();
    };
    var selectMedicineUnit = function(item) {
        router.replace({
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queries), {
                treatmentMedicineUnitId: item.id
            })
        });
        closeModal();
    };
    var onCloseSearchAddressFilterModal = function() {
        setIsAddressFilterModalOpen(false);
    };
    var onOpenSearchAddressFilterModal = function() {
        setIsAddressFilterModalOpen(true);
    };
    var onOpenMedicineFilterModal = function() {
        showModal({
            type: modal/* MODAL_TYPE.BASIC */.f.BASIC,
            props: {
                body: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NonBenefitFilterModal, {
                    title: "진료 종류를 선택해주세요",
                    list: nonBenefitMedicines.medicines,
                    onClick: selectMedicine,
                    selectedItem: selectedMedicine,
                    getItemName: function(item) {
                        return item.medicineName;
                    }
                }),
                onClickOverlay: closeModal
            }
        });
    };
    var onOpenMedicineUnitFilterModal = function() {
        showModal({
            type: modal/* MODAL_TYPE.BASIC */.f.BASIC,
            props: {
                body: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NonBenefitFilterModal, {
                    title: "처방 단위를 선택해주세요",
                    /* 처방 단위를 최대 3개까지 노출하기로 함 */ list: selectedMedicine.units.slice(0, 3),
                    onClick: selectMedicineUnit,
                    selectedItem: selectedMedicineUnit,
                    getItemName: function(item) {
                        return "".concat(item.unit).concat(item.unitTypeDisplayName);
                    }
                }),
                onClickOverlay: closeModal
            }
        });
    };
    var onClickRelatedMagazine = function(magazinePid) {
        moveToPage({
            webLink: "".concat(common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazinePid),
            mobileScreenName: common/* ROUTES.MAGAZINE.DETAIL.appScreenName */.Z6.MAGAZINE.DETAIL.appScreenName,
            params: {
                id: magazinePid
            }
        });
    };
    var onClickRelatedFaq = function(magazinePid) {
        moveToPage({
            webLink: "".concat(common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(magazinePid),
            mobileScreenName: common/* ROUTES.FAQ.DETAIL.appScreenName */.Z6.FAQ.DETAIL.appScreenName,
            params: {
                id: magazinePid
            }
        });
    };
    var onClickRelatedQuestion = function(questionPid) {
        moveToPage({
            webLink: "".concat(common/* ROUTES.QNA.DETAIL.path */.Z6.QNA.DETAIL.path, "/").concat(questionPid),
            mobileScreenName: common/* ROUTES.QNA.DETAIL.appScreenName */.Z6.QNA.DETAIL.appScreenName,
            params: {
                questionId: questionPid
            }
        });
    };
    var onClickOpenAppInstallLink = function() {
        airbridge/* default.setDeepLink */.Z.setDeepLink({
            buttonID: "selected-medicine-".concat(selectedMedicine.id),
            deeplinkUrl: selectedMedicine.deepLinkUrl,
            ctaParams: {
                cta_param_1: "우리동네진료가격",
                cta_param_2: selectedMedicine.medicineName,
                cta_param_3: selectedMedicine.treatment.name
            }
        });
    };
    var onClickDoctor = function(doctor, medicine) {
        router.push("".concat(common/* ROUTES.DOCTOR.DETAIL.path */.Z6.DOCTOR.DETAIL.path, "/").concat(doctor.publicId).concat((0,url/* addQueryString */.sC)({
            type: "treatment",
            categoryId: medicine.treatment.id,
            treatmentMedicineId: medicine.id
        })));
    };
    var onOpenDiagnosisAppInstallBottomSheet = function() {
        showModal({
            type: modal/* MODAL_TYPE.BASIC */.f.BASIC,
            props: {
                body: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiagnosisAppInstallBottomSheet/* default */.Z, {
                    client: client,
                    treatmentMedicineId: selectedMedicine.id,
                    title: "닥터나우 앱을 설치하면\n".concat(selectedMedicine.treatmentProductMedicineName, " 처방이 가능해요!"),
                    description: "QR 코드를 스캔하면 앱을 설치할 수 있습니다",
                    onClose: closeModal,
                    qrCodeUrl: selectedMedicine.installQrcodeUrl,
                    onClickOpenAppInstallLink: onClickOpenAppInstallLink
                })
            }
        });
    };
    var onClickNextQna = lodash_default().debounce(function() {
        if (!isEnableQnaPagination) {
            return;
        }
        fetchSearchedQnaNextPage();
        setIsEnableQnaPagination(false);
    }, 1000, {
        leading: true,
        trailing: false
    });
    var getSearchAddressFilterModalProps = function() {
        return {
            switchRegionFilter: onCloseSearchAddressFilterModal,
            siDoList: siDoList,
            siGunGuList: siGunGuList,
            dongList: dongList,
            selectedRegion: selectedAddressList,
            onSelectAddress: onSelectAddress,
            onUpdateAddress: onUpdateAddress,
            isOpened: true,
            isSejong: queryRegion.isSejongRegion,
            client: client
        };
    };
    (0,react.useEffect)(function() {
        /* 카테고리 변경시 qna 페이지네이션 재허용 */ setIsEnableQnaPagination(true);
    }, [
        selectedMedicine.treatment.id
    ]);
    return {
        breadCrumbs: breadCrumbs,
        queries: queries,
        qnas: qnas,
        faqs: faqs,
        magazines: magazines,
        isEnableQnaPagination: isEnableQnaPagination,
        nonBenefitPriceTotalSummary: nonBenefitPriceTotalSummary,
        nonBenefitMedicines: nonBenefitMedicines,
        koreaAddress: koreaAddress,
        queryRegion: queryRegion,
        nonBenefitDoctors: nonBenefitDoctors,
        selectedAddressList: selectedAddressList,
        selectedMedicine: selectedMedicine,
        selectedAddressTitle: selectedAddressTitle,
        selectedFullAddressTitle: selectedFullAddressTitle,
        selectedMedicineUnit: selectedMedicineUnit,
        selectedRegionSummary: selectedRegionSummary,
        priceDisplayGapText: priceDisplayGapText,
        isAddressFilterModalOpen: isAddressFilterModalOpen,
        onOpenSearchAddressFilterModal: onOpenSearchAddressFilterModal,
        onOpenMedicineFilterModal: onOpenMedicineFilterModal,
        onOpenMedicineUnitFilterModal: onOpenMedicineUnitFilterModal,
        onClickRelatedMagazine: onClickRelatedMagazine,
        onClickRelatedFaq: onClickRelatedFaq,
        onClickRelatedQuestion: onClickRelatedQuestion,
        onClickDoctor: onClickDoctor,
        onClickNextQna: onClickNextQna,
        onOpenDiagnosisAppInstallBottomSheet: onOpenDiagnosisAppInstallBottomSheet,
        getSearchAddressFilterModalProps: getSearchAddressFilterModalProps
    };
};
/* harmony default export */ var nonBenefit_useNonBenefitHomeViewModel = (useNonBenefitHomeViewModel);

;// CONCATENATED MODULE: ./src/pages/non-benefit/index.tsx
// PageDescription: 지역별, 역주변별 비급여 가격비교 페이지










var NonBenefitHomePages = function(param) {
    var client = param.client;
    var viewModel = nonBenefit_useNonBenefitHomeViewModel(client);
    var _queries = viewModel.queries, treatmentMedicineUnitId = _queries.treatmentMedicineUnitId, regionCode = _queries.regionCode;
    var title = "".concat(viewModel.selectedAddressTitle, " ").concat(viewModel.selectedMedicine.treatmentProductMedicineName, " 최저가 가격 ").concat(viewModel.selectedMedicine.medicineName, " 2025");
    var description = "".concat(viewModel.selectedAddressTitle, " ").concat(viewModel.selectedMedicine.treatmentProductMedicineName, " ").concat(viewModel.selectedMedicine.medicineName, " 성지 병원 가격 비교 - ").concat(viewModel.selectedMedicine.medicineProductName);
    var canonical = "".concat("https://doctornow.co.kr").concat(common/* ROUTES.NON_BENEFIT.HOME.path */.Z6.NON_BENEFIT.HOME.path).concat((0,url/* addQueryString */.sC)({
        treatmentMedicineUnitId: treatmentMedicineUnitId,
        regionCode: regionCode
    }));
    var nonBenefitLdJson = (0,react.useMemo)(function() {
        return (0,format/* nonBenefitSeoLdJson */.r3)({
            doctors: viewModel.nonBenefitDoctors,
            address: viewModel.selectedAddressTitle,
            faqs: viewModel.faqs,
            canonical: canonical
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: title,
                description: description,
                canonical: canonical,
                openGraph: {
                    title: title,
                    description: description,
                    url: canonical,
                    images: [
                        {
                            url: "".concat("https://doctornow-front-images.s3.ap-northeast-2.amazonaws.com/og-main.png"),
                            alt: "Og Image Alt"
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(nonBenefitLdJson)
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(home_NonBenefitHomeTemplate, {
                client: client,
                viewModel: viewModel
            })
        ]
    });
};
NonBenefitHomePages.Layout = DefaultLayout/* default */.Z;
var __N_SSP = true;
/* harmony default export */ var non_benefit = (NonBenefitHomePages);


/***/ }),

/***/ 45162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zg": function() { return /* binding */ MagazineTagType; },
/* harmony export */   "rL": function() { return /* binding */ MagazineType; },
/* harmony export */   "wK": function() { return /* binding */ MagazineBottomButtonType; }
/* harmony export */ });
/* unused harmony exports CoreCategoryType, AuthorType */
var MagazineType = {
    INTERNAL: "INTERNAL",
    EXTERNAL: "EXTERNAL",
    ARTICLE: "ARTICLE",
    FAQ: "FAQ"
};
var MagazineTagType;
(function(MagazineTagType) {
    MagazineTagType["DEPARTMENT"] = "DEPARTMENT";
    MagazineTagType["SYMPTOM"] = "SYMPTOM";
    MagazineTagType["DISEASE"] = "DISEASE";
    MagazineTagType["FREE"] = "FREE";
})(MagazineTagType || (MagazineTagType = {}));
var CoreCategoryType;
(function(CoreCategoryType) {
    CoreCategoryType["Department"] = "DEPARTMENT";
    CoreCategoryType["Disease"] = "DISEASE";
    CoreCategoryType["Symptom"] = "SYMPTOM";
})(CoreCategoryType || (CoreCategoryType = {}));
var AuthorType;
(function(AuthorType) {
    AuthorType["DOCTOR"] = "DOCTOR";
    AuthorType["AI"] = "AI";
    AuthorType["NURSE"] = "NURSE";
})(AuthorType || (AuthorType = {}));
var ProfessionalFieldType;
(function(ProfessionalFieldType) {
    ProfessionalFieldType["DEPARTMENT"] = "DEPARTMENT";
})(ProfessionalFieldType || (ProfessionalFieldType = {}));
var MagazineBottomButtonType;
(function(MagazineBottomButtonType) {
    MagazineBottomButtonType["QUESTION"] = "QUESTION";
    MagazineBottomButtonType["DIAGNOSIS"] = "DIAGNOSIS";
})(MagazineBottomButtonType || (MagazineBottomButtonType = {}));


/***/ }),

/***/ 90377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useDraggable; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;

function useDraggable(ref, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$decayRate = _ref.decayRate,
      decayRate = _ref$decayRate === void 0 ? 0.95 : _ref$decayRate,
      _ref$safeDisplacement = _ref.safeDisplacement,
      safeDisplacement = _ref$safeDisplacement === void 0 ? 10 : _ref$safeDisplacement,
      _ref$applyRubberBandE = _ref.applyRubberBandEffect,
      applyRubberBandEffect = _ref$applyRubberBandE === void 0 ? false : _ref$applyRubberBandE,
      _ref$activeMouseButto = _ref.activeMouseButton,
      activeMouseButton = _ref$activeMouseButto === void 0 ? "Left" : _ref$activeMouseButto,
      _ref$isMounted = _ref.isMounted,
      isMounted = _ref$isMounted === void 0 ? true : _ref$isMounted;

  var internalState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    isMouseDown: false,
    isDraggingX: false,
    isDraggingY: false,
    initialMouseX: 0,
    initialMouseY: 0,
    lastMouseX: 0,
    lastMouseY: 0,
    scrollSpeedX: 0,
    scrollSpeedY: 0,
    lastScrollX: 0,
    lastScrollY: 0
  });
  var isScrollableAlongX = false;
  var isScrollableAlongY = false;
  var maxHorizontalScroll = 0;
  var maxVerticalScroll = 0;
  var cursorStyleOfWrapperElement;
  var cursorStyleOfChildElements;
  var transformStyleOfChildElements;
  var transitionStyleOfChildElements;
  var timing = 1 / 60 * 1000; // period of most monitors (60fps)

  useIsomorphicLayoutEffect(function () {
    if (isMounted) {
      isScrollableAlongX = window.getComputedStyle(ref.current).overflowX === "scroll";
      isScrollableAlongY = window.getComputedStyle(ref.current).overflowY === "scroll";
      maxHorizontalScroll = ref.current.scrollWidth - ref.current.clientWidth;
      maxVerticalScroll = ref.current.scrollHeight - ref.current.clientHeight;
      cursorStyleOfWrapperElement = window.getComputedStyle(ref.current).cursor;
      cursorStyleOfChildElements = [];
      transformStyleOfChildElements = [];
      transitionStyleOfChildElements = [];
      ref.current.childNodes.forEach(function (child) {
        cursorStyleOfChildElements.push(window.getComputedStyle(child).cursor);
        transformStyleOfChildElements.push(window.getComputedStyle(child).transform === "none" ? "" : window.getComputedStyle(child).transform);
        transitionStyleOfChildElements.push(window.getComputedStyle(child).transition === "none" ? "" : window.getComputedStyle(child).transition);
      });
    }
  }, [isMounted]);

  var runScroll = function runScroll() {
    var dx = internalState.current.scrollSpeedX * timing;
    var dy = internalState.current.scrollSpeedY * timing;
    var offsetX = ref.current.scrollLeft + dx;
    var offsetY = ref.current.scrollTop + dy;
    ref.current.scrollLeft = offsetX; // eslint-disable-line no-param-reassign

    ref.current.scrollTop = offsetY; // eslint-disable-line no-param-reassign

    internalState.current.lastScrollX = offsetX;
    internalState.current.lastScrollY = offsetY;
  };

  var rubberBandCallback = function rubberBandCallback(e) {
    var dx = e.clientX - internalState.current.initialMouseX;
    var dy = e.clientY - internalState.current.initialMouseY;
    var _ref$current = ref.current,
        clientWidth = _ref$current.clientWidth,
        clientHeight = _ref$current.clientHeight;
    var displacementX = 0;
    var displacementY = 0;

    if (isScrollableAlongX && isScrollableAlongY) {
      displacementX = 0.3 * clientWidth * Math.sign(dx) * Math.log10(1.0 + 0.5 * Math.abs(dx) / clientWidth);
      displacementY = 0.3 * clientHeight * Math.sign(dy) * Math.log10(1.0 + 0.5 * Math.abs(dy) / clientHeight);
    } else if (isScrollableAlongX) {
      displacementX = 0.3 * clientWidth * Math.sign(dx) * Math.log10(1.0 + 0.5 * Math.abs(dx) / clientWidth);
    } else if (isScrollableAlongY) {
      displacementY = 0.3 * clientHeight * Math.sign(dy) * Math.log10(1.0 + 0.5 * Math.abs(dy) / clientHeight);
    }

    ref.current.childNodes.forEach(function (child) {
      child.style.transform = "translate3d(" + displacementX + "px, " + displacementY + "px, 0px)"; // eslint-disable-line no-param-reassign

      child.style.transition = "transform 0ms"; // eslint-disable-line no-param-reassign
    });
  };

  var recoverChildStyle = function recoverChildStyle() {
    ref.current.childNodes.forEach(function (child, i) {
      child.style.transform = transformStyleOfChildElements[i]; // eslint-disable-line no-param-reassign

      child.style.transition = transitionStyleOfChildElements[i]; // eslint-disable-line no-param-reassign
    });
  };

  var rubberBandAnimationTimer;
  var keepMovingX;
  var keepMovingY;

  var callbackMomentum = function callbackMomentum() {
    var minimumSpeedToTriggerMomentum = 0.05;
    keepMovingX = setInterval(function () {
      var lastScrollSpeedX = internalState.current.scrollSpeedX;
      var newScrollSpeedX = lastScrollSpeedX * decayRate;
      internalState.current.scrollSpeedX = newScrollSpeedX;
      var isAtLeft = ref.current.scrollLeft <= 0;
      var isAtRight = ref.current.scrollLeft >= maxHorizontalScroll;
      var hasReachedHorizontalEdges = isAtLeft || isAtRight;
      runScroll();

      if (Math.abs(newScrollSpeedX) < minimumSpeedToTriggerMomentum || internalState.current.isMouseDown || hasReachedHorizontalEdges) {
        internalState.current.scrollSpeedX = 0;
        clearInterval(keepMovingX);
      }
    }, timing);
    keepMovingY = setInterval(function () {
      var lastScrollSpeedY = internalState.current.scrollSpeedY;
      var newScrollSpeedY = lastScrollSpeedY * decayRate;
      internalState.current.scrollSpeedY = newScrollSpeedY;
      var isAtTop = ref.current.scrollTop <= 0;
      var isAtBottom = ref.current.scrollTop >= maxVerticalScroll;
      var hasReachedVerticalEdges = isAtTop || isAtBottom;
      runScroll();

      if (Math.abs(newScrollSpeedY) < minimumSpeedToTriggerMomentum || internalState.current.isMouseDown || hasReachedVerticalEdges) {
        internalState.current.scrollSpeedY = 0;
        clearInterval(keepMovingY);
      }
    }, timing);
    internalState.current.isDraggingX = false;
    internalState.current.isDraggingY = false;

    if (applyRubberBandEffect) {
      var transitionDurationInMilliseconds = 250;
      ref.current.childNodes.forEach(function (child) {
        child.style.transform = "translate3d(0px, 0px, 0px)"; // eslint-disable-line no-param-reassign

        child.style.transition = "transform " + transitionDurationInMilliseconds + "ms"; // eslint-disable-line no-param-reassign
      });
      rubberBandAnimationTimer = setTimeout(recoverChildStyle, transitionDurationInMilliseconds);
    }
  };

  var preventClick = function preventClick(e) {
    e.preventDefault();
    e.stopImmediatePropagation(); // e.stopPropagation();
  };

  var getIsMousePressActive = function getIsMousePressActive(buttonsCode) {
    return activeMouseButton === "Left" && buttonsCode === 1 || activeMouseButton === "Middle" && buttonsCode === 4 || activeMouseButton === "Right" && buttonsCode === 2;
  };

  var onMouseDown = function onMouseDown(e) {
    var isMouseActive = getIsMousePressActive(e.buttons);

    if (!isMouseActive) {
      return;
    }

    internalState.current.isMouseDown = true;
    internalState.current.lastMouseX = e.clientX;
    internalState.current.lastMouseY = e.clientY;
    internalState.current.initialMouseX = e.clientX;
    internalState.current.initialMouseY = e.clientY;
  };

  var onMouseUp = function onMouseUp(e) {
    var isDragging = internalState.current.isDraggingX || internalState.current.isDraggingY;
    var dx = internalState.current.initialMouseX - e.clientX;
    var dy = internalState.current.initialMouseY - e.clientY;
    var isMotionIntentional = Math.abs(dx) > safeDisplacement || Math.abs(dy) > safeDisplacement;
    var isDraggingConfirmed = isDragging && isMotionIntentional;

    if (isDraggingConfirmed) {
      ref.current.childNodes.forEach(function (child) {
        child.addEventListener("click", preventClick);
      });
    } else {
      ref.current.childNodes.forEach(function (child) {
        child.removeEventListener("click", preventClick);
      });
    }

    internalState.current.isMouseDown = false;
    internalState.current.lastMouseX = 0;
    internalState.current.lastMouseY = 0;
    ref.current.style.cursor = cursorStyleOfWrapperElement; // eslint-disable-line no-param-reassign

    ref.current.childNodes.forEach(function (child, i) {
      child.style.cursor = cursorStyleOfChildElements[i]; // eslint-disable-line no-param-reassign
    });

    if (isDraggingConfirmed) {
      callbackMomentum();
    }
  };

  var onMouseMove = function onMouseMove(e) {
    if (!internalState.current.isMouseDown) {
      return;
    }

    e.preventDefault();
    var dx = internalState.current.lastMouseX - e.clientX;
    internalState.current.lastMouseX = e.clientX;
    internalState.current.scrollSpeedX = dx / timing;
    internalState.current.isDraggingX = true;
    var dy = internalState.current.lastMouseY - e.clientY;
    internalState.current.lastMouseY = e.clientY;
    internalState.current.scrollSpeedY = dy / timing;
    internalState.current.isDraggingY = true;
    ref.current.style.cursor = "grabbing"; // eslint-disable-line no-param-reassign

    ref.current.childNodes.forEach(function (child) {
      child.style.cursor = "grabbing"; // eslint-disable-line no-param-reassign
    });
    var isAtLeft = ref.current.scrollLeft <= 0 && isScrollableAlongX;
    var isAtRight = ref.current.scrollLeft >= maxHorizontalScroll && isScrollableAlongX;
    var isAtTop = ref.current.scrollTop <= 0 && isScrollableAlongY;
    var isAtBottom = ref.current.scrollTop >= maxVerticalScroll && isScrollableAlongY;
    var isAtAnEdge = isAtLeft || isAtRight || isAtTop || isAtBottom;

    if (isAtAnEdge && applyRubberBandEffect) {
      rubberBandCallback(e);
    }

    runScroll();
  };

  var handleResize = function handleResize() {
    maxHorizontalScroll = ref.current.scrollWidth - ref.current.clientWidth;
    maxVerticalScroll = ref.current.scrollHeight - ref.current.clientHeight;
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (isMounted) {
      window.addEventListener("mouseup", onMouseUp);
      window.addEventListener("mousemove", onMouseMove);
      window.addEventListener("resize", handleResize);
    }

    return function () {
      window.removeEventListener("mouseup", onMouseUp);
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("resize", handleResize);
      clearInterval(keepMovingX);
      clearInterval(keepMovingY);
      clearTimeout(rubberBandAnimationTimer);
    };
  }, [isMounted]);
  return {
    events: {
      onMouseDown: onMouseDown
    }
  };
}


//# sourceMappingURL=react-use-draggable-scroll.esm.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2182,6577,1498,3886,4329,6562,6870,1743,3281,5247,2026,3018,6512,8625,3336,9774,2888,179], function() { return __webpack_exec__(45971); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);